import React, { useEffect, useState, useRef } from 'react';
import Board, { moveCard } from '@asseinfo/react-kanban';
import '@asseinfo/react-kanban/dist/styles.css';
import { useStore } from '../../app/stores/store';
import { observer } from 'mobx-react-lite';
import TaskFormModal from '../MediaAssets/Details/TaskFormModal';

function KanBanMain({
  board,
  setOnkanbanData,
  OnkanbanData,
  closeTaskFormModal,
  activeOrder,
  completeSubtask,
  taskData,
  taskId,
  hideSubtask,
  currSubTaskData,
  CardHandler,
  redirectPage1,
}) {
  const {
    KanbanStore,
    activityStore,
    // userStore,
  } = useStore();

  // const { user } = userStore;
  // const history = history();
  const {
    Kanbandatapass,
    ModelSubtaskInfo,
    kanbanDestinationInfomation,
    KanbanDestinationId,
    ModelTaskInfo,
  } = KanbanStore;
  const [controlledBoard, setBoard] = useState(board);
  const [eleModalTitle, setEleModalTitle] = useState([]);
  const [isClockCheker, setIsClockChker] = useState(false);
  // const [destinationId,setDestinationId] = useState("");

  const cardDetails = useRef();

  // //taskform data

  useEffect(() => {
    setBoard(board);
  }, [board]);

  function handleCardMove(card, source, destination) {
    const NormalCardMover = () => {
      source.fromColumnId = destination.toColumnId;
      const updatedBoard = moveCard(controlledBoard, source, destination);
      !updatedBoard && setBoard(updatedBoard);
      setIsClockChker(false);
    };

    const UpdateCardMover = () => {
      const updatedBoard = moveCard(controlledBoard, source, destination);
      setBoard(updatedBoard);
      setIsClockChker(true);
      Kanbandatapass(
        card.id,
        card.title,
        source.fromColumnId,
        destination.toColumnId,
      );
    };
    kanbanDestinationInfomation(
      destination?.toColumnId,
      true,
      source.fromColumnId,
    );

    // UpdateCardMover();
    switch (source?.fromColumnId) {
      case 0:
        if (destination?.toColumnId === 1) {
          UpdateCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        } else {
          NormalCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        }
        break;
      case 1:
        if (destination?.toColumnId === 2) {
          UpdateCardMover();
          KanbanStore.KanbancompleteTriggerBtn = true;
        } else if (destination?.toColumnId === 3) {
          UpdateCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        } else if (destination?.toColumnId === 5) {
          UpdateCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        } else {
          NormalCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        }
        break;
      case 2:
        NormalCardMover();
        break;
      case 3:
        if (destination?.toColumnId === 4) {
          UpdateCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        } else {
          NormalCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        }
        break;
      case 4:
        if (destination?.toColumnId === 1) {
          UpdateCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        } else {
          NormalCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        }
        break;
      case 5:
        if (destination?.toColumnId === 7) {
          UpdateCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        } else if (destination?.toColumnId === 6) {
          UpdateCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        } else {
          NormalCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        }
        break;
      case 6:
        if (destination?.toColumnId === 7) {
          UpdateCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        } else {
          NormalCardMover();
          KanbanStore.KanbancompleteTriggerBtn = false;
        }
        break;
      case 7:
        NormalCardMover();
        KanbanStore.KanbancompleteTriggerBtn = false;
        break;
      default:
        NormalCardMover();
        KanbanStore.KanbancompleteTriggerBtn = false;
        break;
    }
    cardDetails.current = card;

    let itemTitle = ' / ' + card.description;
    const taskTitleRight = card.description.split('/')[0];
    const taskTittleLeft = card.description.split('/')[1];
    KanbanStore.kanbansubtaskLeftTittle = taskTittleLeft;
    KanbanStore.kanbansubtaskRightTittle = taskTitleRight;
    activityStore.selectedActivity = card;
    setEleModalTitle(itemTitle);
    setOnkanbanData(true);

    setTimeout(() => {
      addEventListerFunction();
    }, 500);
  }

  const tittleInfo = (data1, e) => {
    const dataId = controlledBoard?.columns?.filter((data) => {
      return KanbanDestinationId === data.id;
    });
    const data2 = dataId?.[0]?.cards.filter((data) => {
      return data1 === data.title;
    });

    if (data2?.length === 0 || data2?.length === undefined) {
      const dataId = controlledBoard?.columns?.filter((data) => {
        return KanbanStore.KanbanSourceId === data.id;
      });
      const data3 = dataId?.[0]?.cards.filter((data) => {
        return data1 === data.title;
      });
      if (data3?.length !== 0) {
        redirectPage1(data3[0]?.id);
      } else {
        CardHandler(e);
      }
    } else if (data2?.length !== 0 || data2?.length !== undefined) {
      redirectPage1(data2[0]?.id);
      // history(`/mediaAssets/${data2[0].id}`);
    }
  };

  const addEventListerFunction = () => {
    const cardsElement = Array.from(
      document.getElementsByClassName('react-kanban-card '),
    );
    const cards = board.columns;

    let count = 0;
    cards?.forEach((data) => {
      data.cards.forEach((card) => {
        if (card !== undefined && data !== undefined && count !== undefined) {
          cardsElement[count].setAttribute('data-id', card?.id);
          cardsElement[count].setAttribute('data-title', data?.id);
          count++;
        }
      });
    });

    cardsElement.forEach((data) => {
      data.addEventListener('click', (e) => {
        const dataaa = e?.path?.[1].innerHTML
          .split('</span>')[0]
          ?.split('<span>')[2];
        if (dataaa !== undefined) {
          KanbanStore.Kanban_backend_task_Data !== '' && tittleInfo(dataaa, e);
          KanbanStore.Kanban_backend_task_Data === '' && CardHandler(e);
        }
        if (dataaa === undefined) {
          const data = e?.target?.innerText;
          KanbanStore.Kanban_backend_task_Data !== '' && tittleInfo(data, e);
          KanbanStore.Kanban_backend_task_Data === '' && CardHandler(e);
        }
      });
    });
  };

  useEffect(() => {
    addEventListerFunction();

    // eslint-disable-next-line
  }, []);
  const workflowHistoryHandler = () => {};
  return (
    <>
      <br />

      <Board
        style={{ marginTop: '20px' }}
        onCardDragEnd={handleCardMove}
        // onCardDragEnd={handleCardMove}
        disableColumnDrag
      >
        {controlledBoard}
      </Board>

      {OnkanbanData &&
      activeOrder.templateId !== '' &&
      isClockCheker === true ? (
        <TaskFormModal
          taskname={ModelTaskInfo?.taskName}
          showTasksModal={OnkanbanData}
          closeTaskFormModal={closeTaskFormModal}
          assignedUsers={[]}
          selectedSubTask={ModelSubtaskInfo}
          eleModalTitle={eleModalTitle}
          subTaskIdNo={currSubTaskData?.subTaskId}
          completeSubtask={completeSubtask}
          taskData={taskData}
          taskId={taskId}
          currSubTaskData={currSubTaskData}
          hideSubtask={hideSubtask}
          workflowHistoryHandler={workflowHistoryHandler}
        />
      ) : null}
    </>
  );
}
export default observer(KanBanMain);
